module.exports = __webpack_public_path__ + "static/media/daily-cash@2x.bbd3f8b3.png";